"use client";

// Kennfarbe einer Gruppe: dieselbe Palette wie die Personenfarben
// (`lib/person-colors.ts`), als Reihe zum Antippen — ohne Popover,
// damit sie im Dialog auch auf dem Telefon mit einem Tipp geht.
import { Check } from "lucide-react";
import { PERSON_COLOR_PRESETS, avatarColorStyle } from "@/lib/person-colors";
import { cn } from "@/lib/utils";

export function Farbwahl({
  wert,
  onChange,
  name,
}: {
  wert: string | null;
  onChange: (farbe: string | null) => void;
  /** Fuer die FormData. */
  name?: string;
}) {
  return (
    <div role="radiogroup" aria-label="Kennfarbe" className="flex flex-wrap gap-1.5">
      {name && <input type="hidden" name={name} value={wert ?? ""} />}
      <button
        type="button"
        role="radio"
        aria-checked={wert === null}
        onClick={() => onChange(null)}
        title="Keine Farbe"
        className={cn(
          "ring-border-strong text-caption text-text-tertiary grid h-7 w-7 place-items-center rounded-full ring-1 ring-inset",
          "duration-fast transition-shadow",
          wert === null && "ring-accent ring-2",
        )}
      >
        <span aria-hidden>–</span>
      </button>
      {PERSON_COLOR_PRESETS.map((p) => {
        const an = wert === p.hex;
        return (
          <button
            key={p.key}
            type="button"
            role="radio"
            aria-checked={an}
            aria-label={p.label}
            title={p.label}
            onClick={() => onChange(p.hex)}
            style={avatarColorStyle(p.hex)}
            className={cn(
              "grid h-7 w-7 place-items-center rounded-full bg-[var(--person-color)]",
              "duration-fast ring-offset-bg-primary transition-shadow",
              an ? "ring-accent ring-2 ring-offset-2" : "hover:ring-border-strong hover:ring-2 hover:ring-offset-1",
            )}
          >
            {an && <Check className="text-text-inverse h-3.5 w-3.5" strokeWidth={3} aria-hidden />}
          </button>
        );
      })}
    </div>
  );
}
